import { useQuery } from "@tanstack/react-query";
import { getAllCurrencies } from "../services/currencies";

export function useCurrency() {
  return useQuery({
    queryKey: ["useCurrency", { symbol: "currency" }],
    queryFn: getAllCurrencies,
    staleTime: 60 * 60 * 1000 * 24 * 24,
    // @ts-ignore
    cacheTime: 60 * 60 * 1000 * 24 * 24,
    gcTime: Infinity,
    refetchOnMount: false,
    refetchInterval: false,
    refetchOnWindowFocus: false,
  });
}
